import { DollarSign } from '@tamagui/lucide-icons';
import { NetSavings } from '@unistocks/features/dashboard/components/dashboard-data/net-savings/net-savings';
import { queryFilter } from '@unistocks/features/dashboard/components/dashboard-data/net-savings/query-filter';
import {
  NetSavingsSettings,
  netSavingsSchemaFactory
} from '@unistocks/features/dashboard/components/dashboard-data/net-savings/settings';
import { DashboardItemDescriptor } from '@unistocks/features/dashboard/dashboard-item-descriptor';

export const dashboardItemDescriptor: DashboardItemDescriptor = {
  component: NetSavings,
  settingsSteps: [NetSavingsSettings],
  schemaFactory: netSavingsSchemaFactory,
  defaults: setValue => {
    setValue('barChartSettings', { combineBars: true });
  },
  queryFilter: queryFilter,
  icon: DollarSign
};
